<template>
  <div class="input-range-wrapper slider-pricing">
    <input
      type="range"
      @input="handle"
      min="1"
      :max="pricing2.length"
      value="0"
      :style="`--custom-color: ${color}; --progress:
  ${((selectedRange - min) * 100) / (pricing2.length - min)}%`"
    />
    <span
      class="range-tooltip"
      :style="`--left-position: ${((selectedRange - min) * 100) / (pricing2.length - min)}%`"
      v-tooltip="{
        content: modelValue <= 50 ? modelValue : '+',
        shown: showTooltip,
        triggers: [],
        popperClass: 'input-range-tooltip',
      }"
    />
    <div class="badge-ticks ticks">
      <div
        v-for="(price, index) in pricing2"
        :key="index"
        class="badge-container"
      >
        <div
          class="range-badge"
          v-text="badgeLabel(price)"
        />
        <div
          :class="{
            show: getGiftNumber(price),
            current: selectedRange - 1 == index,
          }"
          class="gift-badge"
        >
          <i class="bi bi-gift" />
          {{ getGiftNumber(price) }} offerte{{
            getGiftNumber(price) > 1 ? "s" : ""
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, computed } from "vue";

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  color: {
    type: String,
    default: "#F2CB36",
  },
  pricing: {
    type: Array,
    required: true,
  },
  default: {
    type: Number,
    default: 1,
  },
});

const emits = defineEmits(["update:modelValue"]);

const showTooltip = ref(false);
const timeout = ref<NodeJS.Timeout | undefined>(undefined);

export interface Pricing {
  amount: number;
  gift: number;
  price: number;
}

const pricing2 = computed(() => {
  const prices = props.pricing.concat() as Pricing[];
  prices.push({
    amount: 100,
    gift: 0,
    price: 0,
  });
  return prices.sort((a, b) => a.amount - b.amount);
});

/**
 * Minimum quantiy of credits that can be purchased.
 */
const min = computed(() => {
  return Math.min.apply(Math, pricing2.value.map(elt => elt.amount));
});

/**
 * Maximum quantiy of credits that can be purchased.
 */
const max = computed(() => {
  return Math.max.apply(Math, pricing2.value.map(elt => elt.amount));
});

function badgeLabel(price: Pricing) {
  if (price.amount === max.value) return "+";
  return price.amount;
}

function getGiftNumber(price: Pricing) {
  return price.gift;
}

const selectedPrice = computed(() => {
  return pricing2.value.find((elt) => elt.amount === props.modelValue);
});

/**
 * Index of the input range that is selected. Goes from 1 to pricing2.length.
 */
const selectedRange = ref(1);

function handle(e) {
  selectedRange.value = e.target.value;
  if (e.target.value <= 0) e.target.value = 1;
  if (e.target.value >= max.value) e.target.value = max.value;

  if (showTooltip.value) {
    clearTimeout(timeout.value);
  } else {
    showTooltip.value = true;
  }

  timeout.value = setTimeout(() => {
    showTooltip.value = false;
  }, 1000);

  
  const price = pricing2.value[e.target.value - 1];

  emits("update:modelValue", price?.amount || 1);
}

/*
function goTo(price: Pricing) {
  console.log("goTooooo", price);
  const index = pricing2.value.findIndex((elt) => elt.amount === price.amount);
  range.value.value = index;

  emits("update:modelValue", price.amount);
}
  */

onMounted(() => {
  emits("update:modelValue", props.default);
});
</script>
